type Props = {
  title: string;
  disabled?: boolean;
  theme?: 'sub';
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  onClick?: (e: React.MouseEvent) => void;
};

export default function Button({ title, type, onClick, disabled, theme }: Props): JSX.Element {
  return (
    <div className="flex flex-col w-full">
      <button
        disabled={disabled}
        type={type ? type : 'button'}
        onClick={(e) => onClick && onClick(e)}
        className={[
          theme === 'sub'
            ? ['border', 'border-very-light-grey', 'text-black', 'N_14_M', 'bg-white', 'focus:text-opacity-50', 'focus:text-black'].join(
                ' ',
              )
            : ['border', 'border-bluey-purple', 'text-white', 'N_14_R', 'bg-bluey-purple', 'focus:bg-active-bluey-purple'].join(' '),
          disabled &&
            (theme === 'sub' ? 'text-brown-grey opacity-50' : 'bg-light-grey-blue border-light-grey-blue text-opacity-50 text-white'),
          'py-3',
          'rounded-sm',
        ].join(' ')}
      >
        {title}
      </button>
    </div>
  );
}
